export class ValueWrapper {
    constructor(value) {
        this.value = value;
    }
}
